// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headers[data-v-74f46d1b]{display:flex;flex-direction:row;justify-content:space-evenly;align-items:center;border-bottom:1px solid var(--border);height:30px}.headers div[data-v-74f46d1b]{width:100%}.row[data-v-74f46d1b]:not(:last-of-type){margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
